export const isBrowser = false;
export const isNode = true;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
